import Vue from 'vue'
import VueResource from 'vue-resource'
import VueRouter from 'vue-router'
import Routes from './routes'

var VueScrollTo = require('vue-scrollto');

import App from './App.vue'

Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

Vue.config.productionTip = false;



const router = new VueRouter({
  routes: Routes,
  mode: 'history'
});


new Vue({
  render: h => h(App),
  router: router
}).$mount('#app');
